import { Component, OnDestroy, OnInit } from "@angular/core"
import { Subscription } from "rxjs"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"
import { ColorCodeService } from "../../services/color-code.service"

@Component({
    selector: "app-browsing-header",
    templateUrl: "./browsing-header.component.html",
    styleUrls: ["./browsing-header.component.scss"],
})
export class BrowsingHeaderComponent implements OnInit, OnDestroy {
    public node: CHNode
    public backgroundColor = null
    public subscriptions: Subscription[] = []

    constructor(
        private browsingService: BrowsingService,
        private colorCodeService: ColorCodeService
    ) {
        this.backgroundColor = this.colorCodeService.getPrimaryColor()
    }

    public ngOnInit() {
        this.subscriptions.push(
            this.browsingService.activeNodeChanged.subscribe((node: CHNode) => {
                const discipline = node.getDiscipline()
                const subject = node.getSubject()
                this.node = subject || discipline
                this.backgroundColor = this.colorCodeService.getColorForNode(discipline)
            })
        )
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
